import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";
import ShortFilmModal from "../component/FilmModal/ShortFilmModal";

const MainLayout = () => {
	const [showFilmModal, setShowFilmModal] = useState(false);

	// Pop up video modal ONCE on initial site visit (saved in sessionStorage)
	useEffect(() => {
		const hasSeenModal = sessionStorage.getItem("hasSeenFilmModal");
		if (!hasSeenModal) {
			const timer = setTimeout(() => {
				setShowFilmModal(true);
				sessionStorage.setItem("hasSeenFilmModal", "true");
			}, 100);
			return () => clearTimeout(timer);
		}
	}, []);

	return (
		<>
			<Header onOpenFilmModal={() => setShowFilmModal(true)} />
			<div
				style={{
					overflowY: "scroll",
					scrollbarWidth: "none",
				}}>
				<Outlet />
			</div>
			<Footer />
			<ShortFilmModal
				isOpen={showFilmModal}
				onClose={() => setShowFilmModal(false)}
			/>
		</>
	);
};
export default MainLayout;

